/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RetailerId } from './RetailerId';

export type OfferItemIdentityUpdate = {
    type?: OfferItemIdentityUpdate.type;
    value?: string;
    partialMatchThreshold?: number;
    fullMatchThreshold?: number;
    merchants?: Array<RetailerId>;
    isActive?: boolean;
};

export namespace OfferItemIdentityUpdate {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

